import { render, staticRenderFns } from "./SearchResultSection.vue?vue&type=template&id=5d79a6c5&scoped=true&"
import script from "./SearchResultSection.vue?vue&type=script&lang=js&"
export * from "./SearchResultSection.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultSection.vue?vue&type=style&index=0&id=5d79a6c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d79a6c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d79a6c5')) {
      api.createRecord('5d79a6c5', component.options)
    } else {
      api.reload('5d79a6c5', component.options)
    }
    module.hot.accept("./SearchResultSection.vue?vue&type=template&id=5d79a6c5&scoped=true&", function () {
      api.rerender('5d79a6c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/search/components/SearchResultSection.vue"
export default component.exports